export default __webpack_public_path__ + "static/media/family2.f57ccf80.svg";